var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportPdf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 77,
    viewBox: "0 0 64 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 77,
    rx: 8,
    fill: "#EEEEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6182_18407)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11,
    width: 44,
    height: 56,
    rx: 5,
    fill: "#E1635A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 7H58V31L45.5 19.5L32 7Z",
    fill: "#F1A19C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.084 39.959H21.9102V38.5879H24.084C24.4199 38.5879 24.6934 38.5332 24.9043 38.4238C25.1152 38.3105 25.2695 38.1543 25.3672 37.9551C25.4648 37.7559 25.5137 37.5312 25.5137 37.2812C25.5137 37.0273 25.4648 36.791 25.3672 36.5723C25.2695 36.3535 25.1152 36.1777 24.9043 36.0449C24.6934 35.9121 24.4199 35.8457 24.084 35.8457H22.5195V43H20.7617V34.4688H24.084C24.752 34.4688 25.3242 34.5898 25.8008 34.832C26.2812 35.0703 26.6484 35.4004 26.9023 35.8223C27.1562 36.2441 27.2832 36.7266 27.2832 37.2695C27.2832 37.8203 27.1562 38.2969 26.9023 38.6992C26.6484 39.1016 26.2812 39.4121 25.8008 39.6309C25.3242 39.8496 24.752 39.959 24.084 39.959ZM31.1152 43H29.2578L29.2695 41.6289H31.1152C31.5762 41.6289 31.9648 41.5254 32.2812 41.3184C32.5977 41.1074 32.8359 40.8008 32.9961 40.3984C33.1602 39.9961 33.2422 39.5098 33.2422 38.9395V38.5234C33.2422 38.0859 33.1953 37.7012 33.1016 37.3691C33.0117 37.0371 32.877 36.7578 32.6973 36.5312C32.5176 36.3047 32.2969 36.1348 32.0352 36.0215C31.7734 35.9043 31.4727 35.8457 31.1328 35.8457H29.2227V34.4688H31.1328C31.7031 34.4688 32.2246 34.5664 32.6973 34.7617C33.1738 34.9531 33.5859 35.2285 33.9336 35.5879C34.2812 35.9473 34.5488 36.377 34.7363 36.877C34.9277 37.373 35.0234 37.9258 35.0234 38.5352V38.9395C35.0234 39.5449 34.9277 40.0977 34.7363 40.5977C34.5488 41.0977 34.2812 41.5273 33.9336 41.8867C33.5898 42.2422 33.1777 42.5176 32.6973 42.7129C32.2207 42.9043 31.6934 43 31.1152 43ZM30.2539 34.4688V43H28.4961V34.4688H30.2539ZM38.0586 34.4688V43H36.3008V34.4688H38.0586ZM41.457 38.1133V39.4844H37.5781V38.1133H41.457ZM41.8672 34.4688V35.8457H37.5781V34.4688H41.8672Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6182_18407"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11,
    width: 44,
    height: 56,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportPdf);
export default __webpack_public_path__ + "static/media/report-pdf.90145aa5ed34fb476657adfa7370c8e5.svg";
export { ForwardRef as ReactComponent };